function openContactModal() {
    var $ = jQuery.noConflict();
    var html = '<div class="contact-box">Bel <b>0800 - BULLSEYE</b> (of 0800 - 285 573 93) of mail naar <b><a target="_blank" href="mailto:info@bullseye.nl">info@bullseye.nl</a></b>.<br />' +
        '<br /><br />' +
        '<div class="text-center"><a href="#" class="button primary cancel-button">Venster sluiten</a></div></div>';
    show_modal("Contact", html);
    return false;
}